module.exports = __webpack_public_path__ + "static/media/special-thanks.fef01a40.md";